import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import Reaptcha from "reaptcha";
import ScaleLoader from "react-spinners/RotateLoader";
import Modal from "react-modal";
import FormikErrorFocus from "formik-error-focus";
import axios from "axios";

import "./App.css";

function App() {
  const REACT_APP_GOOGLE_CAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY;

  const [processing, setProcessing] = useState(false);
  const [message, setMessage] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };

  const submitForm = (values) => {
    setProcessing(true);

    console.log(values);

    // Check if email is valid
    axios({
      method: "post",
      url: process.env.REACT_APP_API_URL + "/v1/contestEntries/enterContest",
      timeout: 4000,
      data: {
        whatHuntingSytleDoYouPrefer: values.whatHuntingSytleDoYouPrefer,
        whatInformationIsHelpful: values.whatInformationIsHelpful,
        firstname: values.firstname,
        lastname: values.lastname,
        email: values.email,
        consent: values.consent,
        disclaimerConsent: values.disclaimerConsent,
        captcha: values.captcha,
      },
    })
      //* Evaluate received response
      .then((res) => {
        if (res.data.message) {
          setMessage(res.data.message);
        } else {
          setMessage("No message received from server.");
        }
        setProcessing(false);

        setTimeout(() => {
          setMessage("");
          closeModal();
          window.scrollTo(0, 0);
        }, 4000);
      })
      .catch((err) => {
        console.log(err);
        setMessage("There was an error processing your entry (ER:ZYKK8B49). Please try again later.");
        setProcessing(false);

        setTimeout(() => {
          setMessage("");
          closeModal();
          window.scrollTo(0, 0);
        }, 4000);
      });
  };

  return (
    <div>
      <div>
        <div>
          <button className="btn btn-primary btn-lg" onClick={openModal}>
            Enter Contest
          </button>

          <Modal
            isOpen={modalIsOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            // style={customStyles}
            contentLabel="Example Modal"
          >
            {processing ? (
              <div className="processingContainer">
                <ScaleLoader
                  color={"black"}
                  loading={true}
                  cssOverride={true}
                  size={15}
                  margin={2}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            ) : (
              <div>
                {message ? (
                  <div className="processingContainer">
                    <div className="messageConatiner">
                      <center>
                        <h3>{message}</h3>
                      </center>
                    </div>
                  </div>
                ) : (
                  <Formik
                    initialValues={{
                      firstname: "",
                      lastname: "",
                      email: "",
                      confirmEmail: "",
                      whatHuntingSytleDoYouPrefer: "",
                      whatInformationIsHelpful: "",
                      consent: [],
                      disclaimerConsent: [],
                      captcha: "",
                    }}
                    validate={(values) => {
                      const errors = {};

                      // Validate email
                      if (!values.email) {
                        errors.email = "Required";
                      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                        errors.email = "Invalid email address";
                      }

                      // Validate email confirmation
                      if (!values.confirmEmail) {
                        errors.confirmEmail = "Required";
                      } else if (values.email !== values.confirmEmail) {
                        errors.confirmEmail = "Confirm email address does not match email address.";
                      }

                      // Validate favorite guest
                      // if (!values.whatHuntingSytleDoYouPrefer) {
                      //   errors.whatHuntingSytleDoYouPrefer = 'Required';
                      // }

                      // Validate What information did you find most helpful?
                      // if (!values.whatInformationIsHelpful) {
                      //   errors.whatInformationIsHelpful = 'Required';
                      // } else if (values.whatInformationIsHelpful.length < 3) {
                      //   errors.whatInformationIsHelpful =
                      //     'Must be 8 characters or more';
                      // }

                      // Validate captcha
                      if (!values.firstname) {
                        errors.firstname = "Required";
                      }

                      // Validate captcha
                      if (!values.lastname) {
                        errors.lastname = "Required";
                      }

                      // Validate captcha
                      if (!values.captcha) {
                        errors.captcha = "Required";
                      }

                      // Validate Disclaimer Consent
                      if (values.disclaimerConsent.length === 0) {
                        errors.disclaimerConsent = "Required";
                      }

                      return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                      submitForm(values);
                    }}
                  >
                    {({
                      values,
                      errors,
                      setFieldValue,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                    }) => (
                      <Form>
                        <h2>Contest Entry Form</h2>
                        {/* <div className="mb-3">
                          <div className="row">
                            <div className="col-md-6">
                              <label
                                htmlFor="favoriteGuest"
                                className="form-label form-question"
                              >
                                Whatz type of hunting style do your prefer?
                                <span className="form-required"> *</span>
                              </label>
                              <Field
                                as="select"
                                name="whatHuntingSytleDoYouPrefer"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.whatHuntingSytleDoYouPrefer}
                              >
                                <option value="">Choose One</option>
                                <option value="archery">Archery</option>
                                <option value="rifle">Rifle</option>
                                <option value="shotgun">Shotgun</option>
                                <option value="all of the above">
                                  All of the above
                                </option>
                                <option value="I'm not sure">
                                  I'm not sure
                                </option>
                              </Field>
                              <div className="form-text form-error">
                                {errors.whatHuntingSytleDoYouPrefer &&
                                  touched.whatHuntingSytleDoYouPrefer &&
                                  errors.whatHuntingSytleDoYouPrefer}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <label
                                htmlFor="whatInformationIsHelpful"
                                className="form-label form-question"
                              >
                                What information would you find helpful on our
                                website?
                                <span className="form-required"> *</span>
                              </label>
                              <Field
                                as="select"
                                name="whatInformationIsHelpful"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.whatInformationIsHelpful}
                              >
                                <option value="">Choose one</option>
                                <option value="Hunting Tips">
                                  Hunting tips
                                </option>
                                <option value="Recipes">Recipes</option>
                                <option value="Podcasts">Podcasts</option>
                                <option value="I'm new here">
                                  I'm new here
                                </option>
                              </Field>
                              <div className="form-text form-error">
                                {errors.whatInformationIsHelpful &&
                                  touched.whatInformationIsHelpful &&
                                  errors.whatInformationIsHelpful}
                              </div>
                            </div>
                          </div>{' '}
                        </div> */}

                        <div className="mb-3">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="firstname" className="form-label form-question">
                                First name:
                                <span className="form-required">*</span>
                              </label>
                              <input
                                type="firstname"
                                name="firstname"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.firstname}
                              />
                              <div className="form-text form-error">
                                {errors.firstname && touched.firstname && errors.firstname}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <label htmlFor="lastname" className="form-label form-question">
                                Last name:
                                <span className="form-required"> *</span>
                              </label>
                              <input
                                type="lastname"
                                name="lastname"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                              />
                              <div className="form-text form-error">
                                {errors.lastname && touched.lastname && errors.lastname}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="mb-3">
                          <div className="row">
                            <div className="col-md-6">
                              <label htmlFor="email" className="form-label form-question">
                                Email: <span className="form-required">*</span>
                              </label>
                              <input
                                type="email"
                                name="email"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                              />
                              <div className="form-text form-error">
                                {errors.email && touched.email && errors.email}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <label htmlFor="email" className="form-label form-question">
                                Confirm email:
                                <span className="form-required"> *</span>
                              </label>
                              <input
                                type="confirmEmail"
                                name="confirmEmail"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                              />
                              <div className="form-text form-error">
                                {errors.confirmEmail && touched.confirmEmail && errors.confirmEmail}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="mb-3">
                          <label className="form-check">
                            <Field
                              className="form-check-input"
                              type="checkbox"
                              name="consent"
                              value="Alberta Hunter Education Instructors Association (AHEIA)"
                            />
                            <label className="form-check-label">
                              I'd like to receive emails from Alberta Hunter Education Instructors’ Association (AHEIA).
                            </label>
                          </label>
                          <label className="form-check">
                            <Field
                              className="form-check-input"
                              type="checkbox"
                              name="consent"
                              value="I'd like to receive emails from Harvest Your Own for articles, recipes, and giveaways."
                            />
                            <label className="form-check-label">
                              I'd like to receive emails from Harvest Your Own for articles, recipes, and giveaways.
                            </label>
                          </label>

                          <div className="form-text form-error">
                            {errors.consent && touched.consent && errors.consent}
                          </div>
                        </div>

                        <div className="mb-3">
                          <label className="form-check">
                            <Field
                              className="form-check-input"
                              type="checkbox"
                              name="disclaimerConsent"
                              value="I agree to the terms of the disclaimer."
                            />
                            <label className="form-check-label">
                              <span>
                                I agree to the terms of the{" "}
                                <a
                                  rel="noreferrer"
                                  href="https://www.ab-conservation.com/about/privacy-disclaimer"
                                  target="_blank"
                                >
                                  disclaimer
                                </a>
                                .<span className="form-required"> *</span>
                              </span>
                            </label>
                          </label>
                          <div className="form-text form-error">
                            {errors.disclaimerConsent && touched.disclaimerConsent && errors.disclaimerConsent}
                          </div>
                        </div>
                        <div className="mb-3">
                          <Reaptcha
                            sitekey={REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
                            onVerify={(value) => setFieldValue("captcha", value)}
                            onExpire={() => setFieldValue("captcha", "")}
                          />

                          <div className="form-text form-error">
                            {errors.captcha && touched.captcha && errors.captcha}
                          </div>
                        </div>
                        <div className="mb-3">
                          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                            Submit
                          </button>
                          <FormikErrorFocus offset={0} align={"top"} focusDelay={100} ease={"linear"} duration={100} />
                        </div>
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            )}
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default App;
